import { getLogger } from "./UnifiedLogger.jsx";

const { logInfo } = getLogger("AppConstant", true);

export const LANGUAGES = [
  { code: "en", label: "English", isActive: true },
  { code: "as", label: "Assamese (অসমীয়া)", isActive: true },
  { code: "bn", label: "Bengali (বাংলা)", isActive: true },
  { code: "brx", label: "Bodo (बड़ो)", isActive: true },
  { code: "doi", label: "Dogri (डोगरी)", isActive: true },
  { code: "gom", label: "Goan Konkani (गोवा कोंकणी)", isActive: true },
  { code: "gu", label: "Gujarati (ગુજરાતી)", isActive: true },
  { code: "hi", label: "Hindi (हिन्दी)", isActive: true },
  { code: "kn", label: "Kannada (ಕನ್ನಡ)", isActive: true },
  { code: "ks", label: "Kashmiri (کٲشُر)", isActive: true },
  { code: "mai", label: "Maithili (मैथिली)", isActive: true },
  { code: "ml", label: "Malayalam (മലയാളം)", isActive: true },
  { code: "mni", label: "Manipuri (মণিপুরী)", isActive: true },
  { code: "mr", label: "Marathi (मराठी)", isActive: true },
  { code: "ne", label: "Nepali (नेपाली)", isActive: true },
  { code: "or", label: "Odia (ଓଡ଼ିଆ)", isActive: true },
  { code: "pa", label: "Punjabi (ਪੰਜਾਬੀ)", isActive: true },
  { code: "sa", label: "Sanskrit (संस्कृत)", isActive: true },
  { code: "sat", label: "Santali (संताली)", isActive: true },
  { code: "sd", label: "Sindhi (سنڌي)", isActive: true },
  { code: "ta", label: "Tamil (தமிழ்)", isActive: true },
  { code: "te", label: "Telugu (తెలుగు)", isActive: true },
  { code: "ur", label: "Urdu (اردو)", isActive: true },
];

export const getUnsupportedLanguages = () => {
  return LANGUAGES.map((lang) => lang.code);
};
logInfo(
  "SUPPORTED_LANGUAGE",
  "Live Languages",
  getUnsupportedLanguages().join(", ")
);

export const getLanguageData = (code) =>
  LANGUAGES.find((lang) => lang.code === code) || null;
